import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { ButtonView, View, ViewCollection, FocusCycler } from 'ckeditor5/src/ui';
import icon from './footnote_icon.svg';

export class SBFootnotePlugin extends Plugin {

    static get pluginName() {
        return 'SBFootnote';
    }

    init() {
        const editor = this.editor;
        this.bind('sbOpenFootnoteModal').to(editor, 'sbOpenFootnoteModal');

        editor.ui.componentFactory.add( 'sbFootnote', locale => {
            const linkCommand = editor.commands.get( 'link' );
            const view = new ButtonView( locale );

            view.set( {
                label: editor.t( 'Insert Footnote' ),
                icon: icon,
                tooltip: true
            } );

            view.bind( 'isEnabled' ).to( linkCommand, 'isEnabled' );

            // Execute the command.
            this.listenTo( view, 'execute', () => {
                this.sbOpenFootnoteModal();
            } );

            return view;
        } );
    }
}
